import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsfile-upload',
	templateUrl:'./BSFileUploadPage.html',
	styles: [],
	styleUrls:['./BSFileUploadPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSFileUploadPage
{
	mdContent_109 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.fileupload.BSFileUpload;
\`\`\``;
	mdContent_110 = `\`\`\`java
new BSFileUpload<>()
\`\`\``;
	mdContent_111 = `\`\`\`java
var upload = new BSFileUpload<>();
form.add(upload);
\`\`\``;
}
